import { render } from "./Goals.vue?vue&type=template&id=6e2502f7"
import script from "./Goals.vue?vue&type=script&lang=js"
export * from "./Goals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/application/Goals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e2502f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e2502f7', __exports__)) {
    api.reload('6e2502f7', __exports__)
  }
  
  module.hot.accept("./Goals.vue?vue&type=template&id=6e2502f7", () => {
    api.rerender('6e2502f7', render)
  })

}


export default __exports__